import axios from '@/utils/request'

export default {

  // 2020-08-18
  findByProductId(productId) {
    return axios.get('/quotations/find-by-product-id/' + productId)
  },
  //  2020-08-18
  delete(id) {
    return axios.delete('/quotations/' + id)
  },
  // 2020-08-18
  update(id, params) {
    return axios.put('/quotations/' + id, params)
  },
  // 2020-08-19
  insertBatch(params) {
    return axios.post('/quotations/insert-batch', params)
  },
  // 2020-08-28
  inquirierSearch(params) {
    return axios.get('/quotations/inquirier-search', params)
  },
  // 2020-08-29
  findById(id) {
    return axios.get('/quotations/' + id)
  },
  // 2020-08-29
  qtyToQuoter() {
    return axios.get('/quotations/qty-to-quoter')
  },
  // 2021-03-16
  qtyToInquirier() {
    return axios.get('/quotations/qty-to-inquirier')
  },
  // 2020-08-29
  deleteByCustomerId(customerId) {
    return axios.delete('/quotations/delete-by-customer-id/' + customerId)
  },

  // 2020-08-29
  quoterSearch(params) {
    return axios.get('/quotations/quoter-search', params)
  },
  // 2020-08-30
  deleteByIds(params) {
    return axios.post('/quotations/delete-by-ids', params)
  },
  // 2020-09-23
  findByCustomerIdAndProductNo(customerId, params) {
    return axios.get('/quotations/find-by-customer-id/' + customerId + '/product-no', params)
  }
}

